import React, { useEffect, useState } from 'react';
import { Form, Input, Button, Drawer, Space, Upload, Col, Row, Select, Result } from 'antd';
import '../../../style/page.css'
import { Plus, Send } from 'lucide-react';
import { AddNewEnquiry } from '../../../service/api';
import { useNavigate } from 'react-router-dom';


const NewEnquiry = () => {
    const navigate = useNavigate()
    const [open, setOpen] = useState(false);
    const [form] = Form.useForm();
    const [isLoading, setIsloading] = useState(false)
    const [isEnquiry, setIsEnquiry] = useState(false)

    const showDrawer = () => {
        setOpen(true);
    };
    const onClose = () => {
        setOpen(false);
        setIsEnquiry(false)
    };

    const onFinish = async (values) => {
        setIsloading(true)
        try {
            const res = await AddNewEnquiry(values)
            if (res.status === 201) {
                setIsloading(false)
                setOpen(false);

            }
        } catch (error) {
            setIsloading(false)
            console.log(error)

        }
    };

    const onFinishFailed = (errorInfo) => {
        console.log('Validation Failed:', errorInfo);
    };

    const handleCancel = () => {
        form.resetFields();
    };

    return (
        <>
            <Button block type='primary' onClick={showDrawer}><Plus size={16} />  Add Profile</Button>
            <Drawer
                title="Add New Account"
                closable={{ 'aria-label': 'Close Button' }}
                onClose={onClose}
                open={open}
                width={460}
            >
                {!isEnquiry ? <Result
                    status="404"
                    title="Please add or send  enquiry for new account"
                    subTitle="You don’t have any profiles yet. Start by adding a new profile or sending an enquiry."
                    extra={<Space>
                        <Button block type='primary' onClick={() => {
                            navigate('/add-new-profile')
                            setOpen(false)
                        }}><Plus size={16} />  Add New Profile</Button>

                        <Button block type='primary' onClick={() => setIsEnquiry(true)}><Send size={16} /> Send Enquiry</Button>

                    </Space>}
                /> : <Form
                    layout="vertical"
                    form={form}
                    name="add-service-form"
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}

                >
                    <Col className="gutter-row" span={24}>
                        <Form.Item
                            name="schoolName"
                            label="School Name"
                            rules={[{ required: true, message: 'Please enter school  name' }]}
                        >
                            <Input placeholder="Enter School  Name" size='large' />
                        </Form.Item>
                    </Col>
                    <Col className="gutter-row" span={24}>
                        <Form.Item
                            name="locationName"
                            label="Location  Name"
                            rules={[{ required: true, message: 'Please enter location   name' }]}
                        >
                            <Input placeholder="Enter Location Name" size='large' />
                        </Form.Item>
                    </Col>
                    <Col className="gutter-row" span={24}>
                        <Form.Item
                            name="numberOfAdmins"
                            label="No. of Admin"
                            rules={[{ required: true, message: 'Please enter number of admin   ' }]}
                        >
                            <Input placeholder="Enter Number of Admin" size='large' />
                        </Form.Item>
                    </Col>

                    <Col className="gutter-row" span={24}>
                        <Form.Item
                            name="numberOfTeachers"
                            label="No. of Teachers"
                            rules={[{ required: true, message: 'Please enter number of teachers   ' }]}
                        >
                            <Input placeholder="Enter Number of Teachers" size='large' />
                        </Form.Item>
                    </Col>
                    <Col className="gutter-row" span={24}>
                        <Form.Item
                            name="numberOfStudents"
                            label="No. of Students"
                            rules={[{ required: true, message: 'Please enter Number of Students   ' }]}
                        >
                            <Input placeholder="Enter Number of Students" size='large' />
                        </Form.Item>
                    </Col>

                    {/* Description */}
                    <Form.Item
                        name="Notes"
                        label="Notes"
                        rules={[{ required: true, message: 'Please enter Notes' }]}
                    >
                        <Input.TextArea placeholder="Enter Note..." />
                    </Form.Item>
                    <Form.Item  >

                        <div className='submit_btn'>
                            <Space>
                                <Button type="primary" loading={isLoading} htmlType="submit">
                                    Send Enquiry
                                </Button>
                                <Button danger htmlType="button" onClick={handleCancel}>
                                    Reset
                                </Button>
                            </Space>
                        </div>
                    </Form.Item>
                </Form >}
            </Drawer>
        </>
    );
};

export default NewEnquiry